module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_m_erythristic.304b4614.png";